var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inv-warning",class:{ 
    'inv-warning--success': _vm.success,
    'inv-warning--error': _vm.error,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }